import React from 'react'

import { AttentionOutlined, Icon } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { bool } from 'prop-types'

import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'

// Always rendered so its height is reserved; the inputs above never shift when
// the error toggles on an invalid code.
function ErrorMessage({ hasError }) {
  const t = useTranslation()

  return (
    <div className="ai-sign-in-modal__code-error" role="alert">
      {hasError && (
        <>
          <Icon color="warning" notSpaced size="small" svgComponent={AttentionOutlined} />
          <span className="cgt-caption-semibold ai-sign-in-modal__code-error-text">
            {t('signIn.code.invalidCode')}
          </span>
        </>
      )}
    </div>
  )
}

ErrorMessage.propTypes = {
  hasError: bool.isRequired,
}

export default ErrorMessage
